<template>
  <div class="description-page">
    <h1>Транслитерация</h1><h3>кириллица в латиницу и обратно</h3>
  </div>
  <div class="translit">
    <p class="lbl lbl-left">
      {{ direction === 'cyr2lat' ? 'Кириллица' : 'Латиница' }}
    </p>
    <button
      class="btn menlor-border swap-btn"
      title="Сменить направление транслитерации"
      @click="swapDirection"
    >
      ⇄
    </button>
    <p class="lbl lbl-right">
      {{ direction === 'cyr2lat' ? 'Латиница' : 'Кириллица' }}
    </p>
    <textarea
      v-model="sourceText"
      class="menlor-border"
      spellcheck="false"
    />
    <div class="middle">
      <p class="group-title">
        Набор
      </p>
      <button
        class="btn menlor-border set-btn"
        :class="{'set-active': charset === 'ya'}"
        title="Транслитерация по гост я-ya, ч-ch, ш-sh"
        @click="charset = 'ya'"
      >
        я-ya
      </button>
      <button
        class="btn menlor-border set-btn"
        :class="{'set-active': charset === 'k'}"
        title="Госномер. Если буквы не может быть в латинице, она удаляется"
        @click="charset = 'k'"
      >
        a111aa77
      </button>
      <p class="group-title">
        Модификаторы
      </p>
      <button
        class="btn menlor-border set-btn"
        :class="{'set-active': modifier === 'upper'}"
        title="Сделать все буквы заглавными"
        @click="toggleModifier('upper')"
      >
        a-&gt;A
      </button>
      <button
        class="btn menlor-border set-btn"
        :class="{'set-active': modifier === 'lower'}"
        title="Сделать все буквы строчными"
        @click="toggleModifier('lower')"
      >
        A-&gt;a
      </button>
    </div>
    <textarea
      class="menlor-border"
      :value="resultText"
      readonly
      spellcheck="false"
    />
  </div>
  <div class="separator" />
  <div class="description-page">
    <p>Набор <b>я-ya</b> — транслитерация по ГОСТ 7.79-2000 (система Б): я-ya, ч-ch, ш-sh, щ-shh, ц-cz, ж-zh, ё-yo.</p>
    <p>Набор <b>a111aa77</b> — для автомобильных госномеров: заменяются только буквы, имеющие аналог в латинице (АВЕКМНОРСТУХ → ABEKMHOPCTYX), остальные буквы удаляются.</p>
    <p>Кнопка ⇄ меняет направление транслитерации: текст из правого поля становится исходным.</p>
  </div>
</template>

<script>
const CYR_YA_MAP = {
  'а': 'a', 'б': 'b', 'в': 'v', 'г': 'g', 'д': 'd', 'е': 'e', 'ё': 'yo',
  'ж': 'zh', 'з': 'z', 'и': 'i', 'й': 'j', 'к': 'k', 'л': 'l', 'м': 'm',
  'н': 'n', 'о': 'o', 'п': 'p', 'р': 'r', 'с': 's', 'т': 't', 'у': 'u',
  'ф': 'f', 'х': 'x', 'ц': 'cz', 'ч': 'ch', 'ш': 'sh', 'щ': 'shh',
  'ъ': "''", 'ы': 'y', 'ь': "'", 'э': 'e`', 'ю': 'yu', 'я': 'ya',
}

const LAT_K_MAP = {
  'а': 'a', 'в': 'b', 'е': 'e', 'к': 'k', 'м': 'm', 'н': 'h', 'о': 'o',
  'р': 'p', 'с': 'c', 'т': 't', 'у': 'y', 'х': 'x',
}

const CYR_LETTER = /[\u0400-\u04FF]/
const LAT_LETTER = /[a-z]/i

export default {
  name: "TranslitPage",
  data() {
    return {
      sourceText: '',
      direction: 'cyr2lat',
      charset: 'ya',
      modifier: '',
    }
  },
  computed: {
    forwardMap() {
      return this.charset === 'k' ? LAT_K_MAP : CYR_YA_MAP
    },
    reverseMap() {
      const rev = {}
      for (const [cyr, lat] of Object.entries(this.forwardMap)) {
        if (!(lat in rev)) rev[lat] = cyr
      }
      return rev
    },
    reverseKeys() {
      return Object.keys(this.reverseMap).sort((a, b) => b.length - a.length)
    },
    resultText() {
      let text = this.direction === 'cyr2lat'
        ? this.translitForward(this.sourceText)
        : this.translitReverse(this.sourceText)
      if (this.modifier === 'upper') text = text.toUpperCase()
      if (this.modifier === 'lower') text = text.toLowerCase()
      return text
    },
  },
  methods: {
    toggleModifier(name) {
      this.modifier = this.modifier === name ? '' : name
    },
    swapDirection() {
      const prevResult = this.resultText
      this.direction = this.direction === 'cyr2lat' ? 'lat2cyr' : 'cyr2lat'
      this.sourceText = prevResult
    },
    isUpperCyr(char) {
      return char >= '\u0400' && char !== char.toLowerCase()
    },
    translitForward(text) {
      let result = ''
      for (const char of text) {
        const lower = char.toLowerCase()
        if (Object.prototype.hasOwnProperty.call(this.forwardMap, lower)) {
          let lat = this.forwardMap[lower]
          result += this.isUpperCyr(char) ? lat.toUpperCase() : lat
        } else if (this.charset === 'k' && CYR_LETTER.test(char)) {
          // буква не имеет аналога в латинице — удаляется
        } else {
          result += char
        }
      }
      return result
    },
    translitReverse(text) {
      let result = ''
      let i = 0
      while (i < text.length) {
        let matched = false
        for (const key of this.reverseKeys) {
          const seg = text.substring(i, i + key.length)
          if (seg.length === key.length && seg.toLowerCase() === key) {
            const cyr = this.reverseMap[key]
            if (seg === seg.toUpperCase()) {
              result += cyr.toUpperCase()
            } else if (seg[0] === seg[0].toUpperCase()) {
              result += cyr[0].toUpperCase() + cyr.slice(1)
            } else {
              result += cyr
            }
            i += key.length
            matched = true
            break
          }
        }
        if (!matched) {
          const char = text[i]
          if (this.charset === 'k' && LAT_LETTER.test(char)) {
            // латинская буква без аналога в кириллице — удаляется
          } else {
            result += char
          }
          i++
        }
      }
      return result
    },
  },
}
</script>

<style scoped>
.description-page{
  text-align: left;
  padding: 0 20px;
}
.description-page h1{
  text-align: center;
  margin-bottom: 0;
}
.description-page h3{
  text-align: center;
  margin: 0;
}
.description-page p{
  margin-bottom: 0;
  font-size: 0.85em;
}

.translit{
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  grid-template-areas:
    "lbl-l swp lbl-r"
    "src mid res";
  grid-gap: 10px 20px;
  margin: 0 0 20px;
  padding: 10px 20px;
}
.lbl{
  margin: 10px 0 0;
  font-weight: bold;
  align-self: end;
}
.lbl-left{
  grid-area: lbl-l;
  text-align: left;
}
.lbl-right{
  grid-area: lbl-r;
  text-align: right;
}
.swap-btn{
  grid-area: swp;
  margin: 0 auto;
  font-size: 1.1em;
  font-weight: bold;
  min-width: 48px;
}
.translit textarea{
  grid-area: src;
  width: 100%;
  height: 40vh;
  min-height: 200px;
  resize: vertical;
  font-size: 0.9em;
  font-family: inherit;
  box-sizing: border-box;
}
.translit textarea:last-of-type{
  grid-area: res;
}
.translit textarea:focus{
  outline: none;
}
.middle{
  grid-area: mid;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 100px;
}
.group-title{
  margin: 10px 0 5px;
  font-size: 0.8em;
  font-weight: bold;
  text-align: center;
}
.set-btn{
  margin: 5px 2px;
  font-family: monospace;
}
.set-active{
  background-color: black !important;
  color: white;
}

@media screen and (max-width:800px){
  .translit{
    grid-template-columns: 1fr;
    grid-template-areas:
      "lbl-l"
      "swp"
      "mid"
      "src"
      "lbl-r"
      "res";
  }
  .lbl-right{
    text-align: left;
  }
  .middle{
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
  }
  .group-title{
    width: 100%;
  }
}
</style>